import React, { Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../layouts';
import Welcome from '../../../layouts/welcome';
import Row from '../../../components/row';
import Container from '../../../layouts/containers/container';
import List from '../../../components/list';
import Divider from '../../../components/divider/divider';
import ContainerGrid from '../../../layouts/containers/container-grid';
import Grid from '../../../components/grid';
import InputsCounter from '../../../components/inputs/inputs-counter';
import DateTimeInput from '../../../components/inputs/date-time-input';
import LabelContainer from '../../../components/label-container';
import meetingsApi from '../../../lib/meetings/meetings-api';
import Blurred from '../../../components/blurred';

import MediaHelper from '../../../lib/helpers/media';
import Darkener from '../../../components/darkener';
import seamApi from '../../../lib/seam-api';
import dayjs from 'dayjs';
import { SmallPill } from '../../../components/pills';

class NewsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            news: null
        }
    }

    componentDidMount() {
        seamApi.content().page({
            path: `news/${this.props.id}`,
            distribution_id: window.distribution_id,
        }).then((data) => {
            this.setState({ news: data })
        });
    }

    renderFreeContent() {
        const section = this.state.news?.content_version?.body?.sections?.find(s => s.name === 'free content');
        const content = section?.contents;

        return content?.map((item, index) => {
            switch(item?.type) {
                case 'html':
                    return <div dangerouslySetInnerHTML={{ __html: item?.body }}></div>
                case 'text-box':
                    return <p>{ item?.body }</p>
                case 'image':
                    const url = `${this.state.news?.cdn_url}/images/${item?.body}`;

                    return <img style={{ width: '100%' }} data-fslightbox="gallery2" data-type="image" src={url} loading="lazy"></img>
                case 'gallery':
                    return (
                        <div class="freecontent__gallery">
                            <div class="freecontent__gallery-section">
                                { item?.meta?.images?.map((image, i) => {
                                    const url = `${this.state.news?.cdn_url}/images/${image?.file_name}`;

                                    return (
                                        <a class="freecontent__gallery-item lazyload" data-fslightbox="gallery2" data-type="image" href={url} loading="lazy" data-bg={url}></a>
                                    )
                                })}
                            </div>
                        </div>
                    )
            }
        });
    }

    render() {
        if (this.state.news === null) return null;

        return (
            <Layout 
                theme="light"
                topTheme="light"
                topLeft={<Welcome title="Latest DMC Updates" subtitle={this.state.news?.title}/>}
                topRight={
                    <Row gap="20px">
                        
                    </Row>
                }
            >   
                <MinMaxLayout
                    main={
                        <List gap="20px" divider={<Divider/>}>
                            <Grid columns={3} gap="40px">
                                <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Date</Container.Text>}>
                                    { dayjs(this.state.news?.published)?.format('HH:ss DD/MM/YYYY') }
                                </LabelContainer>

                                <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Tags</Container.Text>}>
                                    <Row gap="10px">
                                        { this.state.news?.tags?.map((tag, index) => {
                                            return <SmallPill key={index}>{ tag?.name }</SmallPill>
                                        })}
                                    </Row>
                                </LabelContainer>

                                <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Description</Container.Text>}>
                                    { this.state.news?.description }
                                </LabelContainer>
                            </Grid>

                            { this.renderFreeContent() }
                        </List>
                    }
                />
            </Layout>   
            )
    }
}

const el = document.getElementById('news-page');

if (el) {
    ReactDOM.render(<NewsPage id={el.getAttribute('data-id')}/>, el);
}
